<script setup>
import { mapErrors } from '@/utilities';
import { useForm } from '@inertiajs/vue3';
import { inject, ref } from 'vue';
import { useI18n } from 'vue-i18n';

// Components
import Button from '@/Components/Button/Button.vue';

const submittedForm = ref(false);
const { t } = useI18n();

const form = useForm({
    name: '',
    email: '',
    phone: '',
    message: '',
    subject: '',
});
const route = inject('route');
const sendForm = () => {
    form.post(route('public.forms.contact'), {
        preserveState: true,
        preserveScroll: true,
        onSuccess: () => {
            submittedForm.value = true;
        },
        onError: (errors) => form.errors = mapErrors(errors),

    });
};
</script>

<template>
    <div>
        <div v-if='submittedForm'>
            <div>
                <h2 class='mb-2 text-2xl font-bold'>{{ t('Thank you for your message!') }}</h2>
                {{ t('We have received your message. One of our employees will contact you as soon as possible.') }}
            </div>
        </div>
        <FormKit v-else id='contact-form' :actions='false' type='form' @submit='sendForm'>
            <FormKit
                v-model='form.name'
                :errors='form.errors.name'
                :label="$t('Name *')"
                :value='form.name'
                name='name'
                type='text'
                validation='required|name'
            />

            <FormKit
                v-model='form.email'
                :errors='form.errors.email'
                :label="$t('E-mail *')"
                name='email'
                type='email'
                validation='required|email'

            />

            <FormKit
                v-model='form.phone'
                :errors='form.errors.phone'
                :label="$t('Phone *')"
                :value='form.phone'
                name='phone_number'
                type='text'

            />

            <FormKit
                v-model='form.subject'
                :errors='form.errors.subject'
                :label="$t('Subject *')"
                :value='form.subject'
                name='subject'
                type='text'

            />

            <FormKit
                v-model='form.message'
                :errors='form.errors.message'
                :label="$t('Message *')"
                :value='form.message'
                name='message'
                type='textarea'
            />

            <Button
                :form='form'
                :label="t('Submit')"
                :recentlySuccessful='form.recentlySuccessful'
                admin
                class='w-auto mt-6 '
                type='submit'
            ></Button>


        </FormKit>
    </div>
</template>
